import { gql, useMutation } from '@apollo/client';
import { AnyObject } from '../models/types';

interface ExecuteApiFilteredDataVars {
  url: string;
  domainIdentifier: string;
  instanceId: string;
}

export const EXECUTE_GET_FILTERED_DATA_API = gql`
  mutation ExecuteGetFilteredDataAPI(
    $url: String!
    $domainIdentifier: String
    $instanceId: String
    $piezoArtifacts: JSON
  ) {
    executeGetFilteredDataAPI(
      url: $url
      domainIdentifier: $domainIdentifier
      instanceId: $instanceId
      piezoArtifacts: $piezoArtifacts
    )
  }
`;

export const useExecuteFilteredDataApiMutation = () => {
  return useMutation<AnyObject, ExecuteApiFilteredDataVars>(EXECUTE_GET_FILTERED_DATA_API);
};
